export class PricePolicy {
  id: string;
  cluster: string;
  timeOnJob: number;
  period: number;
  interestRate: number;
  createdBy: string;
  modifiedBy: string;

  constructor(data: string | PricePolicy | DjangoPricePolicy = {}) {
    if (data instanceof PricePolicy) {
      bindPricePolicyData(this, data);
    } else if (typeof data === 'string') {
      bindDjangoPricePolicyData(this, { id: data });
    } else {
      bindDjangoPricePolicyData(this, data);
    }
  }
}

export interface DjangoPricePolicy {
  id?: string;
  cluster?: string;
  time_on_job?: number;
  period?: number;
  interest_rate?: number;
  created_by?: string;
  modified_by?: string;
}

function bindPricePolicyData(pricePolicy: PricePolicy, data: PricePolicy) {
  pricePolicy.id = data.id;
  pricePolicy.cluster = data.cluster;
  pricePolicy.timeOnJob = data.timeOnJob;
  pricePolicy.period = data.period;
  pricePolicy.interestRate = data.interestRate;
  pricePolicy.createdBy = data.createdBy;
  pricePolicy.modifiedBy = data.modifiedBy;
}

function bindDjangoPricePolicyData(pricePolicy: PricePolicy, data: DjangoPricePolicy) {
  pricePolicy.id = data.id;
  pricePolicy.cluster = data.cluster;
  pricePolicy.timeOnJob = data.time_on_job;
  pricePolicy.period = data.period;
  pricePolicy.interestRate = data.interest_rate;
  pricePolicy.createdBy = data.created_by;
  pricePolicy.modifiedBy = data.modified_by;
}

export function parsePricePolicy(data?: string | PricePolicy | DjangoPricePolicy) {
  if (data) {
    return new PricePolicy(data);
  } else {
    return undefined;
  }
}
